import { render, staticRenderFns } from "./MembershipItem.vue?vue&type=template&id=518a30a8&"
import script from "./MembershipItem.vue?vue&type=script&lang=js&"
export * from "./MembershipItem.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/youtube/yt-live-chat-membership-item-renderer.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports